import { platformNames } from 'shared/constants';
import createLightTheme from '@nykaa/nes-ui-components/themes/lightTheme/createLightTheme';

const textColors = {
  darkGrey: '#3A4047',
  lightGrey: '#5C6874',
  darkGreen: '#4FC668',
  lightOrange: '#FF8047',
  brickColor: '#FF7271',
  lightBorder: '#D6D9DC',
  lightBlack: '#595E63',
};
const nykaaPrimaryRgba = (opacity: number): string =>
  `rgba(232, 0, 113,${opacity})`;
const menPrimaryRgba = (opacity: number): string =>
  `rgba(0, 50, 67,${opacity})`;

const NYKAA = {
  brandPrimary: '#E80071',
  brandSecondary: '#FFE1F1',
  brandLight: '#FAC1DE',
  ...textColors,
  brandPrimaryRgba: nykaaPrimaryRgba,
  featuresBak: '#F3F4F5',
  featuresColor: '#3A4047',
  newsletterBak: '#3A4047',
  filterBackground: '#FFF5FB',
};

const MEN = {
  brandPrimary: '#003243',
  brandSecondary: '#A8D6F0',
  brandLight: '#62A3C4',
  ...textColors,
  brandPrimaryRgba: menPrimaryRgba,
  featuresBak: '#003243',
  featuresColor: '#ffffff',
  newsletterBak: '#2C7594',
  filterBackground: '#EDF8FB',
  priceRevealBg: '#F3F4F5',
  lightThemePrimary: '#83C5DB',
  lightThemeInverse: '#62A3C4',
  primary10: '#A8D6F0',
  primary30: '#2C7594',
  primary40: '#09485F',
};

export const getAppTheme = (): Theme => {
  switch (__PLATFORM__) {
    case platformNames.MEN:
      return {
        ...MEN,
        ...createLightTheme({
          colors: {
            primary: MEN.brandPrimary,
            primary40: MEN.primary40,
            primary30: MEN.primary30,
            primary10: MEN.primary10,
            primary20: MEN.lightThemePrimary,
            primaryInverse: MEN.lightThemeInverse,
            secondaryInverse: MEN.lightThemeInverse,
            secondary: MEN.brandPrimary,
          },
        }),
      };
    default:
      return { ...NYKAA, ...createLightTheme({}) };
  }
};
